import { render, staticRenderFns } from "./CustomerMobileView.vue?vue&type=template&id=10d14cd0&scoped=true&"
import script from "./CustomerMobileView.vue?vue&type=script&lang=js&"
export * from "./CustomerMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d14cd0",
  null
  
)

export default component.exports